module.exports = new __parcel__URL__("73091286-2.855f40a9.png").toString();